module.exports = __webpack_public_path__ + "img/029b6ce.jpg";